import React, { FC } from "react";
import { Button, Stack } from "@mui/material";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { NavigationLessAppPage } from "./NavigationLessAppPage";
import { useTranslation } from "react-i18next";
import { useLanguage } from "shared-ts-language";
import { useAppInfo } from "shared-ts-app-info";

export interface UnauthenticatedPageProps {
  booting?: string;
  loginPath?: string;
}

export const UnauthenticatedPage: FC<UnauthenticatedPageProps> = (props) => {
  const { name: appName, icon: appIcon } = useAppInfo();
  const location = useLocation();
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation("shared-ts-ui-app-boot");
  const handleLoginClick = () => {
    if (props.loginPath != null) {
      const returnUrl = location.pathname + location.searchStr;
      navigate({
        to: props.loginPath,
        search: {
          returnUrl: returnUrl,
        } as any,
      });
    }
  };

  return (
    <NavigationLessAppPage
      appName={appName}
      appIcon={appIcon?.large}
      language={language}
      onLanguageChange={setLanguage}
    >
      <Stack useFlexGap gap={2}>
        <Button
          variant={"contained"}
          onClick={handleLoginClick}
          sx={{
            marginTop: "30px",
            alignSelf: "center",
          }}
        >
          {t("Log in")}
        </Button>
      </Stack>
    </NavigationLessAppPage>
  );
};
